/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type CreateStripeCheckoutSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Appearance for new embedded Checkout sessions; existing sessions retain their original theme.
 */
export const Theme = {
  Light: "light",
  Dark: "dark",
} as const;
/**
 * Appearance for new embedded Checkout sessions; existing sessions retain their original theme.
 */
export type Theme = ClosedEnum<typeof Theme>;

export type CreateStripeCheckoutRequest = {
  /**
   * Appearance for new embedded Checkout sessions; existing sessions retain their original theme.
   */
  theme?: Theme | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type CreateStripeCheckoutSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateStripeCheckoutSecurity$outboundSchema: z.ZodMiniType<
  CreateStripeCheckoutSecurity$Outbound,
  CreateStripeCheckoutSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createStripeCheckoutSecurityToJSON(
  createStripeCheckoutSecurity: CreateStripeCheckoutSecurity,
): string {
  return JSON.stringify(
    CreateStripeCheckoutSecurity$outboundSchema.parse(
      createStripeCheckoutSecurity,
    ),
  );
}

/** @internal */
export const Theme$outboundSchema: z.ZodMiniEnum<typeof Theme> = z.enum(Theme);

/** @internal */
export type CreateStripeCheckoutRequest$Outbound = {
  theme: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateStripeCheckoutRequest$outboundSchema: z.ZodMiniType<
  CreateStripeCheckoutRequest$Outbound,
  CreateStripeCheckoutRequest
> = z.pipe(
  z.object({
    theme: z._default(Theme$outboundSchema, "light"),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function createStripeCheckoutRequestToJSON(
  createStripeCheckoutRequest: CreateStripeCheckoutRequest,
): string {
  return JSON.stringify(
    CreateStripeCheckoutRequest$outboundSchema.parse(
      createStripeCheckoutRequest,
    ),
  );
}
